import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { slugs } from '../../Constant/slugs';
import { signInImage } from '../../Constant/api';

export default function HomeScreenLoginTab() {
  const dispatch = useDispatch()

  return (
    <div style={{ minHeight: "100vh", backgroundColor: "#fff", marginTop: 10 }}>
      <div className="row">
        <div style={{ margin: "10px" }} className="center">
          <img
            src={"https://scontent.fbwa3-1.fna.fbcdn.net/v/t39.30808-6/600225096_1342223547916981_1743129127257015682_n.jpg?_nc_cat=105&ccb=1-7&_nc_sid=cc71e4&_nc_ohc=usXcIK_086MQ7kNvwE3NNoo&_nc_oc=AdlKES6FGMRpR6wogikqCfvQebgQ4QkmWflR5XiAZWeLzYw8bFzALSOWyZ3GLBXFxb6J8SfkW3U9Hbx1g7UNfRMw&_nc_zt=23&_nc_ht=scontent.fbwa3-1.fna&_nc_gid=CqZapfwa3iWdP_hXBZoCUg&oh=00_AfkLyqZGACgWvJLmQHt9CzMy4tK-oUNEN2EcAkmR-rjy3Q&oe=694F1DDC"}
            style={{ height: "50vh", width: "100vw", objectFit: "contain" }}
          />
        </div>
        <div className="row center" >
          {/* <Link to={`${slugs.exam}`} className="col-sm-3 col-6 center" style={{ padding: "20px" }}>
            <img
              className="home-icons"
              src="https://api.widihakwon.com/wp-content/uploads/2024/03/examkoreana.png"
            />
            <div className="home-fonts">
              All Exam
            </div>
          </Link> */}
          <Link to={`/tabexam`} className="col-sm-3  col-6 center" style={{ padding: "20px" }}>
            <img
              className="home-icons"
              src="https://api.widihakwon.com/wp-content/uploads/2024/03/video.png"
            />
            <div className="home-fonts">
              Start Exam
            </div>
          </Link>
          {/* <Link to={`${slugs.classroom}`} className="col-sm-3 col-6 center" style={{ padding: "20px" }}>
            <img
              className="home-icons"
              src="https://api.widihakwon.com/wp-content/uploads/2024/03/examkoreana.png"
            />
            <div className="home-fonts">
              Class Exam
            </div>
          </Link>
          <Link to={`${slugs.demo_exam}`} className="col-sm-3 col-6 center">
            <img
              className="home-icons"
              src="https://api.widihakwon.com/wp-content/uploads/2024/03/textbook.png"
            />
            <div className="home-fonts">
              Demo Exam
            </div>
          </Link> */}
        </div>
      </div>
    </div>
  )
}